import React, {useContext} from 'react';
import {LanguageContext} from "../config/multilingualContext";
import MultiLingualContent from "../config/multilingualContent";
import { getLabel } from "../functions/lang";
import ExportDropdown from './ExportDropdown';
import FormattedNumber from './FormattedNumber';
import StatTableBody from './StatTableBody';
import StatTableHead from './StatTableHead';

const Elecqstat = (props) => {
    const { language, toggleLanguage } = useContext(LanguageContext);
    const {configsColumn, tableStatData, configsLine} = props;
    const colors = ['#f2ce61', '#fff2cc', '#94b8da', '#c6e0b4'];
    let colorIndex = -1;

    return (
         <div style={{ width: '100%' }}>
            {tableStatData && Object.keys(tableStatData).length > 0 && 
            <ExportDropdown
                        tableData={tableStatData}
                        columns={configsColumn}
                        filenamePrefix={`elecqstat`}
                        configsLine={configsLine}
                        language={language}
                        showUnitRow={true}
                        showTotal={false}
                    />
            }
        <div style={{ 'overflowY': 'scroll', 'height' : '100vh'}}>
            {Object.keys(tableStatData).length > 0 ? (
                    
                <table
                    className="table table-bordered stripe display mt-2"
                    style={{ width: '100%', overflow: 'scroll' }}
                >
                    <StatTableHead configsColumn={configsColumn} language={language} />
                    <StatTableBody
                        configsLine={configsLine}
                        configsColumn={configsColumn}
                        tableStatData={tableStatData}
                        language={language}
                    />

                </table>
            ) : (
                <p>
                    <MultiLingualContent contentID="nodata" />
                </p>
            )}
        </div>
        </div>
    );

};

export default Elecqstat;